import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/services/api';
import type { League } from '@/types/league';

/** One league record. Every caller shares the cache entry and the request. */
export function useLeague(leagueId: string) {
  return useQuery<League>({
    queryKey: ['league', leagueId],
    queryFn: async () => (await apiClient.getLeague(leagueId)).data.data,
    enabled: !!leagueId,
  });
}
